import StringConverter from '../converter/string-converter'
import globalStore from '../global-store'
import Storage from './storage'

/**
 storage for global stroage
 @packageDocumentation
 */
export interface LocalStorageOption {
  /**
   * value converter
   */
  valueConverter?: StringConverter

  /**
   * key converter
   */
  keyConverter?: StringConverter
}

export default class GlobalStorage extends Storage {
  getItem(key: string): any {
    return globalStore.get(key)
  }

  setItem(key: string, value: any): void {
    globalStore.store(key, value)
    super.addKey(key)
  }

  removeItem(key: string): void {
    globalStore.remove(key)
    super.removeKey(key)
  }
}

export const globalStorage = new GlobalStorage()
